module.exports = __webpack_public_path__ + "static/img/logo-gz.7bee2f1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/logo-gz.jpeg
// module id = P6TO
// module chunks = 1